import React from 'react';
import styled from 'styled-components';
// import { Link } from "react-router-dom";
import arrow_icon from '../images/arrow_icon.png';
import warning from '../images/warning.png';

export default function MypagePWchange({
  updateNext,
  password,
  newPassword,
  newPasswordCheck,
  setPassword,
  setNewPassword,
  setNewPasswordCheck,
  passwordSubmit,
}) {
  const goBack = () => {
    updateNext(-2);
  };

  const finish = () => {
    if (
      passwordVaildate() &&
      newPasswordVaildate() &&
      newPasswordCheckVaildate()
    ) {
      updateNext(-2);
      passwordSubmit();
    } else {
      updateNext(2);
    }
  };

  const passwordChange = (e) => {
    setPassword(e.target.value);
  };
  const newPasswordChange = (e) => {
    setNewPassword(e.target.value);
  };
  const newPasswordCheckChange = (e) => {
    setNewPasswordCheck(e.target.value);
  };

  const passwordVaildate = () => {
    return password.length > 5;
  };
  const newPasswordVaildate = () => {
    //특수기호 포함
 
    //중간단계 (영문 숫자)
    var mediumRegex = new RegExp(
      '^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{8,})',
    );
    return mediumRegex.test(newPassword);
  };
  const newPasswordCheckVaildate = () => {
    return newPasswordCheck === newPassword;
  };
  return (
    <ProfileChange>
      <TopInner style={{ borderBottom: 'solid calc(100vw*(1/375)) #d5d5d5' }}>
        <Back onClick={goBack}>
          <img src={arrow_icon} alt={'back button'} />
        </Back>
        <Title>비밀번호 수정</Title>
        <Finish onClick={finish}> 완료 </Finish>
      </TopInner>

      <Listboxinner>
        <Listbox>
          <ListTit>현재 비밀번호</ListTit>
          <span>
            <Listinput
              type="password"
              placeholder="현재 비밀번호를 입력해 주세요"
              onChange={passwordChange}
              color={
                password.length === 0 || passwordVaildate()
                  ? 'transparent'
                  : '#de0000'
              }
            />
            {password.length === 0 || passwordVaildate() ? null : (
              <Alert>
                <Alerticon>
                  <img src={warning} alt={'alert'}/>
                </Alerticon>
                비밀번호가 일치하지 않습니다
              </Alert>
            )}
          </span>
        </Listbox>

        <Listbox>
          <ListTit>새 비밀번호</ListTit>
          <span>
            <Listinput
              type="password"
              placeholder="영문/숫자 포함 8자 이상"
              onChange={newPasswordChange}
              color={
                newPassword.length === 0 || newPasswordVaildate()
                  ? 'transparent'
                  : '#de0000'
              }
            />
            {newPassword.length === 0 || newPasswordVaildate() ? null : (
              <Alert>
                <Alerticon>
                  <img src={warning} alt='alert'/>
                </Alerticon>
                비밀번호는 영문/숫자 포함 8자 이상으로 설정해 주세요
              </Alert>
            )}
          </span>
        </Listbox>
        <Listbox>
          <ListTit>비밀번호 확인</ListTit>
          <span>
            <Listinput
              type="password"
              placeholder="영문/숫자 포함 8자 이상"
              onChange={newPasswordCheckChange}
              color={
                newPasswordCheck.length === 0 || newPasswordCheckVaildate()
                  ? 'transparent'
                  : '#de0000'
              }
            />
            {newPasswordCheck.length === 0 ||
            newPasswordCheckVaildate() ? null : (
              <Alert>
                <Alerticon>
                  <img src={warning} alt="alert" />
                </Alerticon>
                비밀번호가 일치하지 않습니다
              </Alert>
            )}
          </span>
        </Listbox>
      </Listboxinner>
    </ProfileChange>
  );
}

const ProfileChange = styled.div`
  // padding : calc(100vw*(51/375)) 0 calc(100vw*(110/375)) 0;
`;
const Listboxinner = styled.ul`
  width: 100%;
`;
const Listbox = styled.li`
  display: flex;
  align-items: baseline;
  width: 100%;
  // height: calc(100vw*(55/375));
  border-bottom: solid calc(100vw * (1 / 375)) #eaeaea;
  padding: calc(100vw * (7.5 / 375)) calc(100vw * (17 / 375))
    calc(100vw * (5.5 / 375));
`;
const ListTit = styled.span`
  display: block;
  width: calc(100vw * (93 / 375));
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
`;
const Listinput = styled.input`
  display: block;
  width: calc(100vw * (239 / 375));
  font-size: calc(100vw * (14 / 375));
  padding: 0 calc(100vw * (14 / 375));
  height: calc(100vw * (41 / 375));
  letter-spacing: calc(100vw * (1.3 / 375));
  border-radius: calc(100vw * (5 / 375));
  border: solid calc(100vw * (1 / 375)) ${({ color }) => color};

  &::placeholder {
    color: #c6c6c6;
    font-size: calc(100vw * (14 / 375));
  }
  &:focus {
    border-radius: calc(100vw * (5 / 375));
    border: solid calc(100vw * (1 / 375)) #ffcf19;
  }
`;

const TopInner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 200;
  width: 100%;
  height: calc(100vw * (51 / 375));
  display: felx;
  align-items: center;
  padding: 0 calc(100vw * (17 / 375));
`;
const Title = styled.h1`
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  letter-spacing: 0.32px;
  // margin-left: calc(100vw*(131.2/375));
`;

const Back = styled.a`
  display: block;
  width: calc(100vw * (9.8 / 375));
  height: calc(100vw * (16 / 375));
`;
const Finish = styled.a`
  display: block;
  font-size: calc(100vw * (16 / 375));
  font-weight: 600;
  line-height: 2.83;
  color: #ffc036;
  margin-left: calc(100vw * (-38 / 375));
`;

const Alert = styled.span`
  display: flex;
  display: ${({ display }) => display};
  align-items: center;
  font-size: calc(100vw * (10 / 375));
  color: #de0000;
  margin-top: calc(100vh * (3 / 812));
`;
const Alerticon = styled.em`
  display: inline-block;
  width: calc(100vw * (10 / 375));
  height: calc(100vw * (9 / 375));
  margin-right: calc(100vw * (2.2 / 375));
`;
